export type ExampleOption = { label: string; key: string };

export type ExampleOfferingCategory = {
  label: string;
  key: string;
  options: ExampleOption[];
};

function gradeLabel(grade: number): string {
  const teen = grade % 100;
  const suffix =
    teen >= 11 && teen <= 13
      ? "th"
      : ({ 1: "st", 2: "nd", 3: "rd" } as Record<number, string>)[grade % 10] ??
        "th";
  return `${grade}${suffix} Grade`;
}

const GRADE_OPTIONS: ExampleOption[] = [
  { label: "Kindergarten", key: "grade-k" },
  ...Array.from({ length: 12 }, (_, index) => {
    const grade = index + 1;
    return { label: gradeLabel(grade), key: `grade-${grade}` };
  }),
];

export const EXAMPLE_OFFERING_CATEGORIES: ExampleOfferingCategory[] = [
  {
    label: "Grade",
    key: "grade",
    options: GRADE_OPTIONS,
  },
  {
    label: "Program",
    key: "program",
    options: [
      { label: "Dual Language", key: "program-dual_language" },
      { label: "Arts", key: "program-arts" },
      { label: "STEM", key: "program-stem" },
    ],
  },
  {
    label: "Schedule",
    key: "schedule",
    options: [
      { label: "Half day (AM)", key: "schedule-half_day_am" },
      { label: "Half day (PM)", key: "schedule-half_day_pm" },
      { label: "Full day", key: "schedule-full_day" },
    ],
  },
];

export function optionsForCategoryKey(
  category: ExampleOfferingCategory,
  categoryKey: string
): ExampleOption[] {
  const prefix = `${category.key}-`;
  return category.options.map((option) => {
    const optionKey = option.key.startsWith(prefix)
      ? option.key.slice(prefix.length)
      : option.key;
    return {
      ...option,
      key: categoryKey.length > 0 ? `${categoryKey}-${optionKey}` : optionKey,
    };
  });
}

export function getExampleOfferingCategory(
  key: string
): ExampleOfferingCategory {
  const category =
    EXAMPLE_OFFERING_CATEGORIES.find((item) => item.key === key) ??
    EXAMPLE_OFFERING_CATEGORIES[0];
  if (!category) {
    throw new Error("No offering category templates are configured");
  }
  return category;
}
